<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<h2 class="ma-2 ml-4">Wnioski w zespołach</h2>

		<v-layout row wrap>
			<template v-for="(team, index) in teams">
				<v-flex xs6
					:key="team.id">
					<agency-projects-list
						:projects="team.projects"
						:contest-id="contestData.id"
						:placing-project-allowed="false"
						:editing-visible="false"
						:is-paginated="true"
						:color="team.emptyTeam ? 'grey' : 'teal lighten-' + index"
						:header="team.emptyTeam ? 'Wnioski nieprzypisane' : team.name"
						empty-warning="Brak wniosków">
						<template v-slot:extraAction="slotData">
							<v-list-tile-action>
								<egranty-icon-button icon="swap_vert" color="primary"
									label="Przypisz wniosek do zespołu"
									for="agency-contest-manage-teams-assign-application"
									id="agency-contest-manage-teams-assign-application"
									@click="openProjectAssignDialog(slotData.project.id)"></egranty-icon-button>

							</v-list-tile-action>
						</template>
					</agency-projects-list>
				</v-flex>
			</template>
		</v-layout>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.teamAssignDialogOpen"
			:select-items="teamsWithoutEmpty"
			label="Zespół dla wniosku"
			for="agency-contest-manage-teams-team-for-application"
			id="agency-contest-manage-teams-team-for-application"
			title="Przypisz wniosek do zespołu"
			field-type="SELECT"
			@save="assignSelectedProject">
		</egranty-input-field-popup>
	</div>
</template>

<script>
	import AgencyProjectsList from "../agencyProject/components/AgencyProjectsList";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import {Team} from "@/api/generated/Team";

	export default {
		name: "AgencyContestManageTeamsView",

		components: {EgrantyIconButton, EgrantyInputFieldPopup, AgencyProjectsList},

		data () {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				teams: null,
				teamsWithoutEmpty: null,
				dialogsState: {
					teamAssignDialogOpen: false,
					selectedProjectId: null,
				},
			};
		},

		created () {
			this.reload();
		},

		methods: {
			reload () {
				loadTeamsWithProjects(this);
			},

			openProjectAssignDialog (projectId) {
				this.dialogsState.teamAssignDialogOpen = true;
				this.dialogsState.selectedProjectId = projectId;
			},

			assignSelectedProject (teamId) {
				this.dialogsState.teamAssignDialogOpen = false;

				const projectId = this.dialogsState.selectedProjectId;
				const oldTeam = this.teams.find(c => c.projects.some(o => o.id === projectId));

				if (oldTeam.id === teamId) {
					this.$messagesBus.$emit("success", "Przydział wniosku pozostaje bez zmian");
					return;
				}

				Team.putAssignProject(this, this.dialogsState.selectedProjectId, teamId,
					successResponse => {
						const allProjects = this.teams.map(c => c.projects).flat();
						const thisProject = allProjects.find(o => o.id === projectId);
						this.teams
							.filter(c => c.id === teamId)
							.map(c => c.projects.push(thisProject));

						oldTeam.projects = oldTeam.projects.filter(o => o.id !== projectId);

						this.$messagesBus.$emit("success", "Pomyślnie przypisano wniosek do zespołu", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać wniosku do zespołu", errorResponse);
					});
			}
		},
	};

	function loadTeamsWithProjects (ctx) {
		Team.getContestTeamsWithProjects(ctx, ctx.contestData.id,
			successResponse => {
				ctx.teams = successResponse;
				ctx.teamsWithoutEmpty = successResponse.filter(t => !t.emptyTeam);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować zespołów", errorResponse);
			});
	}
</script>

<style scoped>

</style>
